import { useEffect, useState, useRef } from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S06 = ({ setOffsetTop }) => {
  const containerRef = useRef();
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    message: '',
  });

  useEffect(() => {
    if (containerRef.current) {
      setOffsetTop(containerRef.current.offsetTop);
    }
  }, []);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // 메일 발송
    axios.post('https://flymail.apis.flyground.co.kr/send', {
      key: 'ff0ae956-227c-11ed-861d-0242ac120002',
      to: ['thejinli.official@gmail.com'],
      subject: '웹사이트 접수',
      html: `
          <ul>
            <li>NAME<br />${formValues.name}<br /></li>
            <li>E-MAIL<br />${formValues.email}<br /></li>
            <li>MESSAGE<br />${formValues.message}<br /></li>
          </ul>
        `,
    });

    alert('접수되었습니다.');
    setFormValues({
      name: '',
      email: '',
      message: '',
    });
  };

  return (
    <section ref={containerRef} className={cx('container')}>
      <h3 className={cx('title')}>For Business/Distribution Inquiries</h3>
      <article className={cx('wrapper')}>
        <div className={cx('contacts')}>
          <h4 className={cx('title')}>CONTACT US</h4>
          <ul className={cx('info')}>
            <li>
              <a href="tel:82-70-8758-2022">82-70-8758-2022</a>
            </li>
            <li>
              <a href="https://www.instagram.com/levrai.official/" target="_blank" rel="noreferrer">
                @levrai.official
              </a>
            </li>
            <li>
              <a href="https://www.levraiofficial.com/" target="_blank" rel="noreferrer">
                www.levraiofficial.com
              </a>
            </li>
            <li>
              <a href="mailto:sora.kim@levraiofficial.com">sora.kim@levraiofficial.com</a>
            </li>
          </ul>
        </div>
        <div className={cx('form')}>
          <form onSubmit={onSubmit}>
            <ul className={cx('formList')}>
              <li>
                <label htmlFor="name">
                  <p>NAME</p>
                  <input type="text" name="name" value={formValues.name} required onChange={handleChange} />
                </label>
              </li>
              <li>
                <label htmlFor="email">
                  <p>E-MAIL</p>
                  <input type="email" name="email" value={formValues.email} required onChange={handleChange} />
                </label>
              </li>
              <li>
                <label htmlFor="message">
                  <p>MESSAGE</p>
                  <input type="text" name="message" value={formValues.message} required onChange={handleChange} />
                </label>
              </li>
            </ul>
            <button className={cx('button')} type="submit">
              SEND
            </button>
          </form>
        </div>
      </article>
    </section>
  );
};

export default S06;
